/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} clickInQrGeneratorParams
* @property {string} buttonName - null
* @property {string} component - component name
* @property {string} url - page url
**/
/**
 * Name: Click in QR Generator. Evid: 110.
 * Event description: User clicked in QR Generator.

 * buttonName - Type: string.
 *
 * component - Type: string. Desc: component name
 *
 * url - Type: string. Desc: page url
 * @param {clickInQrGeneratorParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickInQrGenerator = function (params) {
    return { evid: 110, src: 162, endpoint: 'tools', params: params };
};
/**
* @typedef {Object} ctaClickInTheToolsPageParams
* @property {string} buttonType - brand_maker/bng/qr_code_generator etc
* @property {string} url - page url
**/
/**
 * Name: CTA Click in the Tools Page. Evid: 2.
 * Event description: Anon or users clicked on a CTA in the Tools page.

 * buttonType - Type: string. Desc: brand_maker/bng/qr_code_generator etc
 *
 * url - Type: string. Desc: page url
 * @param {ctaClickInTheToolsPageParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var ctaClickInTheToolsPage = function (params) {
    return { evid: 2, src: 162, endpoint: 'tools', params: params };
};
/**
* @typedef {Object} clickInBngParams
* @property {string} buttonName - null
* @property {string} component - component name
* @property {string} url - page url
**/
/**
 * Name: Click in BNG. Evid: 102.
 * Event description: User clicked in the BNG.

 * buttonName - Type: string.
 *
 * component - Type: string. Desc: component name
 *
 * url - Type: string. Desc: page url
 * @param {clickInBngParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var clickInBng = function (params) {
    return { evid: 102, src: 162, endpoint: 'tools', params: params };
};
/**
* @typedef {Object} bngSelectNameParams
* @property {string} buttonName - the button of the selected name
* @property {string} industryName - User industry
* @property {string} url - page url
* @property {string} value - Selected name
**/
/**
 * Name: BNG Select Name. Evid: 103.
 * Event description: User selected name in the BNG.

 * buttonName - Type: string. Desc: the button of the selected name
 *
 * industryName - Type: string. Desc: User industry
 *
 * url - Type: string. Desc: page url
 *
 * value - Type: string. Desc: Selected name
 * @param {bngSelectNameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bngSelectName = function (params) {
    return { evid: 103, src: 162, endpoint: 'tools', params: params };
};
/**
* @typedef {Object} bngSelectIndustryParams
* @property {string} industryName - Chosen industry
* @property {string} url - page url
**/
/**
 * Name: BNG Select Industry. Evid: 101.
 * Event description: User selected an industry in the BNG.

 * industryName - Type: string. Desc: Chosen industry
 *
 * url - Type: string. Desc: page url
 * @param {bngSelectIndustryParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var bngSelectIndustry = function (params) {
    return { evid: 101, src: 162, endpoint: 'tools', params: params };
};
/**
* @typedef {Object} openaiApiCallAttemptParams
* @property {string} key - []
* @property {string} parameters - JSON of parameters included in the prompt
* @property {string} promptType - []
* @property {string} results - JSON of names generated by ai
* @property {number} retryCount - number of retries
* @property {string} status_name - success / fail
* @property {string} toolName - BNG / etc.
* @property {string} url - page url
**/
/**
 * Name: OpenAI API Call Attempt. Evid: 10.
 * Event description: User selected name in the BNG.

 * key - Type: string. Desc: []
 *
 * parameters - Type: string. Desc: JSON of parameters included in the prompt
 *
 * promptType - Type: string. Desc: []
 *
 * results - Type: string. Desc: JSON of names generated by ai
 *
 * retryCount - Type: numeric. Desc: number of retries
 *
 * status_name - Type: string. Desc: success / fail
 *
 * toolName - Type: string. Desc: BNG / etc.
 *
 * url - Type: string. Desc: page url
 * @param {openaiApiCallAttemptParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var openaiApiCallAttempt = function (params) {
    return { evid: 10, src: 162, endpoint: 'tools', params: params };
};
/**
* @typedef {Object} alternativeFlowSignupParams
* @property {string} origin - URL of signup entry point
* @property {string} toolName - BNG/QR Code Generator/etc.
**/
/**
 * Name: Alternative Flow Signup. Evid: 1.
 * Event description: User signed up from any alternative flow tool.

 * origin - Type: string. Desc: URL of signup entry point
 *
 * toolName - Type: string. Desc: BNG/QR Code Generator/etc.
 * @param {alternativeFlowSignupParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var alternativeFlowSignup = function (params) {
    return { evid: 1, src: 162, endpoint: 'tools', params: params };
};
/**
* @typedef {Object} generateNameParams
* @property {string} industryName - Chosen industry
* @property {boolean} isSuggested - TRUE if industry selected from the Business Name by Industry section
* @property {string} search_term - search value
* @property {string} url - page url
**/
/**
 * Name: Generate Name. Evid: 100.
 * Event description: User generated a name in the BNG.

 * industryName - Type: string. Desc: Chosen industry
 *
 * isSuggested - Type: bool. Desc: TRUE if industry selected from the Business Name by Industry section
 *
 * search_term - Type: string. Desc: search value
 *
 * url - Type: string. Desc: page url
 * @param {generateNameParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var generateName = function (params) {
    return { evid: 100, src: 162, endpoint: 'tools', params: params };
};
/**
* @typedef {Object} downloadQrCodeParams
* @property {string} buttonName - null
* @property {string} params - Fully details JSON
* @property {string} url - page url
**/
/**
 * Name: Download QR Code. Evid: 111.
 * Event description: Download QR Code.

 * buttonName - Type: string.
 *
 * params - Type: string. Desc: Fully details JSON
 *
 * url - Type: string. Desc: page url
 * @param {downloadQrCodeParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var downloadQrCode = function (params) {
    return { evid: 111, src: 162, endpoint: 'tools', params: params };
};
//# sourceMappingURL=index.js.map